import { render, staticRenderFns } from "./Read.vue?vue&type=template&id=4da4d1aa&scoped=true&"
import script from "./Read.vue?vue&type=script&lang=js&"
export * from "./Read.vue?vue&type=script&lang=js&"
import style0 from "./Read.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Read.vue?vue&type=style&index=1&id=4da4d1aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da4d1aa",
  null
  
)

export default component.exports